import { render, staticRenderFns } from "./subTitle.vue?vue&type=template&id=cc15d366&"
import script from "./subTitle.vue?vue&type=script&lang=js&"
export * from "./subTitle.vue?vue&type=script&lang=js&"
import style0 from "./subTitle.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports